import { useState, useEffect, useRef } from "react";
import { translations } from "./translations";
import slika1 from "./pics/slika1.jpg";
import slika2 from "./pics/slika2.jpg";
import slika3 from "./pics/slika3.jpg";
import slika4 from "./pics/slika4.jpg";
import slika5 from "./pics/slika5.jpg";
import slika6 from "./pics/slika6.jpg";
import slika7 from "./pics/slika7.jpg";
import slika8 from "./pics/slika8.jpg";
import slika9 from "./pics/slika9.jpg";
import slika10 from "./pics/slika10.jpg";
import slika11 from "./pics/slika11.jpg";
import slika12 from "./pics/slika12.jpg";
import slika13 from "./pics/slika13.jpg";
import slika14 from "./pics/slika14.jpg";
import slika15 from "./pics/slika15.jpg";
import slika16 from "./pics/slika16.jpg";
import slika17 from "./pics/slika17.jpg";
import slika19 from "./pics/slika19.jpg";
import logo from "./pics/Logo Deblji 120x120.png";
import "./App.css";

function App() {
  const [language, setLanguage] = useState("es");
  const [scrolled, setScrolled] = useState(false);
  const [heroOffset, setHeroOffset] = useState(0);
  const [visibleSections, setVisibleSections] = useState({});

  const sectionRefs = {
    section2: useRef(null),
    section3: useRef(null),
    section4: useRef(null),
    section5: useRef(null),
    section6: useRef(null),
    section7: useRef(null),
    section8: useRef(null),
    section9: useRef(null),
    section10: useRef(null),
    section11: useRef(null),
    section12: useRef(null),
    section13: useRef(null),
    section14: useRef(null),
    section15: useRef(null),
    section16: useRef(null),
    section17: useRef(null),
    section18: useRef(null),
    section19: useRef(null),
    section20: useRef(null),
    section21: useRef(null),
    section22: useRef(null),
  };

  const t = translations[language];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setHeroOffset(window.pageYOffset);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    // prevent background scrolling when menu is open
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    const observers = {};

    Object.keys(sectionRefs).forEach((key) => {
      if (sectionRefs[key].current) {
        observers[key] = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setVisibleSections((prev) => ({ ...prev, [key]: true }));
            }
          },
          { threshold: 0.2 },
        );
        observers[key].observe(sectionRefs[key].current);
      }
    });

    return () => {
      Object.keys(observers).forEach((key) => {
        if (observers[key] && sectionRefs[key].current) {
          observers[key].unobserve(sectionRefs[key].current);
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className='app'>
      {/* NAVBAR */}
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className='navbar-container'>
          <div
            className='navbar-logo'
            role='button'
            tabIndex={0}
            onClick={() => scrollToSection("hero")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") scrollToSection("hero");
            }}
          >
            <img src={logo} alt='Logo' />
          </div>

          <div
            className='language-switcher yellow'
            aria-label='Language selector'
          >
            <button
              className={language === "es" ? "active" : ""}
              onClick={() => setLanguage("es")}
            >
              ES
            </button>
            <button
              className={language === "ca" ? "active" : ""}
              onClick={() => setLanguage("ca")}
            >
              CA
            </button>
          </div>

          <div
            className={`hamburger ${menuOpen ? "open" : ""}`}
            role='button'
            tabIndex={0}
            aria-expanded={menuOpen}
            aria-controls='nav-dialog'
            onClick={() => setMenuOpen((s) => !s)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setMenuOpen((s) => !s);
            }}
          />
        </div>
      </nav>

      {menuOpen && (
        <div
          id='nav-dialog'
          className='nav-dialog'
          role='dialog'
          aria-modal='true'
          onClick={() => setMenuOpen(false)}
        >
          <div
            className='nav-dialog-content'
            onClick={(e) => e.stopPropagation()}
          >
            <ul>
              <li
                onClick={() => {
                  scrollToSection("hero");
                  setMenuOpen(false);
                }}
              >
                {t.nav.item1}
              </li>
              <li
                onClick={() => {
                  scrollToSection("section18");
                  setMenuOpen(false);
                }}
              >
                {t.nav.item2}
              </li>
              <li
                onClick={() => {
                  scrollToSection("contact");
                  setMenuOpen(false);
                }}
              >
                {t.nav.item3}
              </li>
            </ul>
          </div>
        </div>
      )}

      {/* HERO SECTION */}
      <section id='hero' className='hero'>
        <div
          className='hero-background'
          style={{ transform: `translateY(${heroOffset * 0.5}px)` }}
        />
        <div className='hero-overlay' />
        <div className='hero-content'>
          <h1 className='hero-title' style={{ opacity: 1 - heroOffset / 500 }}>
            {t.hero.title}
          </h1>
        </div>
      </section>

      {/* SECTION 2 */}
      <section
        id='section2'
        className={`section ${visibleSections.section2 ? "visible" : ""}`}
        ref={sectionRefs.section2}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          <p className='section-text yellow'>{t.section2.text}</p>
        </div>
      </section>

      {/* SECTION 3 */}
      <section
        id='section3'
        className={`section ${visibleSections.section3 ? "visible" : ""}`}
        ref={sectionRefs.section3}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          <h2 className='section-title yellow'>{t.section3.titleYellow}</h2>
          <p className='section-text yellow'>{t.section3.paragraph1}</p>
          <p className='section-text yellow'>{t.section3.paragraph2}</p>
          <div className='section-divider' />
          <p
            className='section-text pale-blue'
            style={{ whiteSpace: "pre-line" }}
          >
            {t.section3.subtextBlue}
          </p>
        </div>
      </section>

      {/* SECTION 4 */}
      <section
        id='section4'
        className={`section ${visibleSections.section4 ? "visible" : ""}`}
        ref={sectionRefs.section4}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          <h2 className='section-title yellow'>{t.section4.titleYellow}</h2>
          <ol className='section-list yellow'>
            {t.section4.points.map((point, idx) => (
              <li key={idx}>{point}</li>
            ))}
          </ol>

          <div className='circle-diagram stack-layout'>
            <div className='row top'>
              <div className='circle-box'>{t.section4.circle.items[0]}</div>
              <div className='operator' aria-hidden='true'>
                +
              </div>
              <div className='circle-box'>{t.section4.circle.items[1]}</div>
              <div className='operator' aria-hidden='true'>
                +
              </div>
              <div className='circle-box'>{t.section4.circle.items[2]}</div>
            </div>

            <div className='row middle'>
              <div className='operator' aria-hidden='true'>
                =
              </div>
              <div className='circle-box center'>{t.section4.circle.title}</div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 - Nutrientes para el cuerpo */}
      <section
        id='section5'
        className={`section-alt ${visibleSections.section5 ? "visible" : ""}`}
        ref={sectionRefs.section5}
      >
        <div className='section-alt-background' />
        <div className='section-alt-overlay' />
        <div className='section-alt-content'>
          <h2 className='section-alt-title'>{t.section5.title}</h2>
        </div>
      </section>

      {/* SECTION 6 - Microgreens Mix */}
      <section
        id='section6'
        className={`section ${visibleSections.section6 ? "visible" : ""}`}
        ref={sectionRefs.section6}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          <h2 className='section-title yellow'>{t.section6.titleYellow}</h2>

          <div className='microgreens-container'>
            <div className='microgreens-image-wrapper'>
              <img
                src={slika1}
                alt='Microgreens'
                className='microgreens-image'
              />
              <div className='microgreen-label top-left'>
                {t.section6.microgreens.topLeft}
              </div>
              <div className='microgreen-label top-right'>
                {t.section6.microgreens.topRight}
              </div>
              <div className='microgreen-label bottom-left'>
                {t.section6.microgreens.bottomLeft}
              </div>
              <div className='microgreen-label bottom-right'>
                {t.section6.microgreens.bottomRight}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 - What are microgreens */}
      <section
        id='section7'
        className={`section ${visibleSections.section7 ? "visible" : ""}`}
        ref={sectionRefs.section7}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          <h2 className='section-title yellow'>{t.section7.titleYellow}</h2>

          {t.section7.paragraphs.map((para, idx) => (
            <p key={idx} className='section-text yellow'>
              {para}
            </p>
          ))}

          <div className='image-centered'>
            <img src={slika12} alt='Microgreens' className='section-image' />
          </div>
        </div>
      </section>

      {/* SECTION 8 - Comparison */}
      <section
        id='section8'
        className={`section-alt ${visibleSections.section8 ? "visible" : ""}`}
        ref={sectionRefs.section8}
      >
        <div className='section-alt-background-pic3' />
        <div className='section-alt-overlay' />
        <div className='section-alt-content'>
          <h2 className='section-title yellow'>{t.section8.titleYellow}</h2>
          {t.section8.paragraphs.map((para, idx) => (
            <p key={idx} className='section-text yellow'>
              {para}
            </p>
          ))}
        </div>
      </section>

      {/* SECTION 9 - Cultivation with images */}
      <section
        id='section9'
        className={`section section-split ${
          visibleSections.section9 ? "visible" : ""
        }`}
        ref={sectionRefs.section9}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content-split'>
          <div className='split-text'>
            {t.section9.textLeft.map((para, idx) => (
              <p key={idx} className='section-text yellow'>
                {para}
              </p>
            ))}
          </div>
          <div className='split-images'>
            <img src={slika2} alt='Cultivation' className='stacked-image' />
            <img src={slika3} alt='LED Growing' className='stacked-image' />
          </div>
        </div>
      </section>

      {/* SECTION 10 - Speed and Effect */}
      <section
        id='section10'
        className={`section ${visibleSections.section10 ? "visible" : ""}`}
        ref={sectionRefs.section10}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          <h2 className='section-title yellow'>{t.section10.title}</h2>
          {t.section10.paragraphs.map((para, idx) => (
            <p key={idx} className='section-text yellow'>
              {para}
            </p>
          ))}

          <div className='image-row'>
            <img src={slika4} alt='Dish 1' />
            <img src={slika5} alt='Dish 2' />
            <img src={slika6} alt='Dish 3' />
            <img src={slika7} alt='Dish 4' />
          </div>

          <h2 className='section-title yellow' style={{ marginTop: "3rem" }}>
            {t.section10.effectTitle}
          </h2>
          {t.section10.effectText.map((para, idx) => (
            <p key={idx} className='section-text yellow'>
              {para}
            </p>
          ))}
        </div>
      </section>

      {/* SECTION 11 - New Reality with mosaic */}
      <section
        id='section11'
        className={`section section-split ${
          visibleSections.section11 ? "visible" : ""
        }`}
        ref={sectionRefs.section11}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content-split'>
          <div className='split-text'>
            <h2 className='section-title yellow'>{t.section11.title}</h2>
            {t.section11.paragraphs.map((para, idx) => (
              <p key={idx} className='section-text yellow'>
                {para}
              </p>
            ))}
          </div>
          <div className='mosaic-images'>
            <img src={slika8} alt='Feature 1' />
            <img src={slika9} alt='Feature 2' />
            <img src={slika10} alt='Feature 3' />
            <img src={slika11} alt='Feature 4' />
          </div>
        </div>
      </section>

      {/* SECTION 12 - Nature nutrients */}
      <section
        id='section12'
        className={`section-picture-bottom ${
          visibleSections.section12 ? "visible" : ""
        }`}
        ref={sectionRefs.section12}
      >
        <div className='section-picture-bg-pic1' />
        <div className='section-alt-overlay' />
        <div className='section-picture-content-bottom'>
          <h2 className='section-title yellow'>{t.section12.title}</h2>
        </div>
      </section>

      {/* SECTION 13 - Magic Carpet */}
      <section
        id='section13'
        className={`section-picture-left ${
          visibleSections.section13 ? "visible" : ""
        }`}
        ref={sectionRefs.section13}
      >
        <div className='section-picture-bg-pic5' />
        <div className='section-alt-overlay' />
        <div className='section-picture-content-left'>
          <h2 className='section-title yellow'>{t.section13.title}</h2>
        </div>
      </section>

      {/* SECTION 14 - Your contribution */}
      <section
        id='section14'
        className={`section ${visibleSections.section14 ? "visible" : ""}`}
        ref={sectionRefs.section14}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          <h2 className='section-title yellow'>{t.section14.title}</h2>
          <p className='section-text yellow'>{t.section14.text}</p>

          <div className='image-split-uneven'>
            <img src={slika17} alt='Magic Carpet 1' className='img-40' />
            <img src={slika15} alt='Magic Carpet 2' className='img-60' />
          </div>
        </div>
      </section>

      {/* SECTION 15 - Organic returns */}
      <section
        id='section15'
        className={`section ${visibleSections.section15 ? "visible" : ""}`}
        ref={sectionRefs.section15}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          {t.section15.paragraphs.map((para, idx) => (
            <p key={idx} className='section-text yellow'>
              {para}
            </p>
          ))}

          <div className='image-three-center'>
            <img src={slika14} alt='Nature 1' />
            <img src={slika13} alt='Nature 2' />
            <img src={slika16} alt='Nature 3' />
            <img src={slika19} alt='Nature 4' />
          </div>
        </div>
      </section>

      {/* SECTION 16 - Classical Music */}
      <section
        id='section16'
        className={`section-picture-right ${
          visibleSections.section16 ? "visible" : ""
        }`}
        ref={sectionRefs.section16}
      >
        <div className='section-picture-bg-pic6' />
        <div className='section-alt-overlay' />
        <div className='section-picture-content-right'>
          <h2 className='section-title yellow'>{t.section16.title}</h2>
        </div>
      </section>

      {/* SECTION 17 - Classical Music Impact */}
      <section
        id='section17'
        className={`section ${visibleSections.section17 ? "visible" : ""}`}
        ref={sectionRefs.section17}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          {t.section17.paragraphs.map((para, idx) => (
            <p key={idx} className='section-text yellow'>
              {para}
            </p>
          ))}
        </div>
      </section>

      {/* SECTION 18 - Phase 2 */}
      <section
        id='section18'
        className={`section-picture-top-left ${
          visibleSections.section18 ? "visible" : ""
        }`}
        ref={sectionRefs.section18}
      >
        <div className='section-picture-bg-pic7' />
        <div className='section-alt-overlay' />
        <div className='section-picture-content-top-left'>
          <h2 className='section-title yellow'>{t.section18.title}</h2>
        </div>
      </section>

      {/* SECTION 19 - Mind nutrients */}
      <section
        id='section19'
        className={`section-picture-bottom-right ${
          visibleSections.section19 ? "visible" : ""
        }`}
        ref={sectionRefs.section19}
      >
        <div className='section-picture-bg-pic8' />
        <div className='section-alt-overlay' />
        <div className='section-picture-content-bottom-right'>
          <h2 className='section-title yellow'>{t.section19.title}</h2>
        </div>
      </section>

      {/* SECTION 20 - 5% Club */}
      <section
        id='section20'
        className={`section ${visibleSections.section20 ? "visible" : ""}`}
        ref={sectionRefs.section20}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          {t.section20.paragraphs.map((para, idx) => (
            <p key={idx} className='section-text yellow'>
              {para}
            </p>
          ))}
        </div>
      </section>

      {/* SECTION 21 - Celebration / next habit (alt bg pic8) */}
      <section
        id='section21'
        className={`section-alt ${visibleSections.section21 ? "visible" : ""}`}
        ref={sectionRefs.section21}
      >
        <div className='section-alt-background-pic9' />
        <div className='section-alt-overlay' />
        <div className='section-alt-content'>
          {t.section21.paragraphs.map((para, idx) => (
            <p key={idx} className='section-text yellow'>
              {para}
            </p>
          ))}
        </div>
      </section>

      {/* SECTION 22 - Follow-up material */}
      <section
        id='section22'
        className={`section ${visibleSections.section22 ? "visible" : ""}`}
        ref={sectionRefs.section22}
      >
        <div className='section-background' />
        <div className='section-overlay' />
        <div className='section-content'>
          {t.section22.yellowText.map((para, idx) => (
            <p
              key={"y" + idx}
              className='section-text yellow'
              dangerouslySetInnerHTML={{ __html: para }}
            />
          ))}

          {t.section22.whiteText.map((para, idx) => (
            <p key={"w" + idx} className='section-text pale-blue'>
              {para}
            </p>
          ))}
        </div>
      </section>

      {/* CONTACT PLACEHOLDER */}
      <section id='contact' className='contact-placeholder'>
        <div className='contact-content'>
          <p>Teléfono: 666 08 08 49</p>
          <p>
            Email:{" "}
            <a href='mailto:microgreens@tierrassa.com'>
              microgreens@tierrassa.com
            </a>
          </p>
          <p>Polígono 09, 43460 Alcover, Tarragona</p>
        </div>
      </section>
    </div>
  );
}

export default App;
